import React from 'react';
import { Table } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

export const DepositsTableHead = () => {
  const { t } = useTranslation();

  return (
    <Table.Row>
      <Table.Cell id="deposits-creation-date">
        {t('containers.deposit_money.deposits_tab.creation_date')}
      </Table.Cell>
      <Table.Cell id="deposits-payment-date">
        {t('containers.deposit_money.deposits_tab.payment_date')}
      </Table.Cell>
      <Table.Cell id="deposits-deposit-id">
        {t('containers.deposit_money.deposits_tab.deposit_id')}
      </Table.Cell>
      <Table.Cell id="deposits-payment-method">
        {t('containers.deposit_money.deposits_tab.payment_method')}
      </Table.Cell>
      <Table.Cell id="deposits-status">
        {t('containers.deposit_money.deposits_tab.status')}
      </Table.Cell>
      <Table.Cell id="deposits-deposit-amount" align="right">
        {t('containers.deposit_money.deposits_tab.deposit_amount')}
      </Table.Cell>
    </Table.Row>
  );
};
